import { useNavigate } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'

interface PointsSummaryBarProps {
  totalPoints: number
  record: { wins: number; draws: number; losses: number }
}

export function PointsSummaryBar({ totalPoints, record }: PointsSummaryBarProps) {
  const navigate = useNavigate()
  const total = record.wins + record.draws + record.losses

  return (
    <div
      onClick={() => navigate('/league')}
      onKeyDown={(e) => e.key === 'Enter' && navigate('/league')}
      role="button"
      tabIndex={0}
      className="rounded-xl border border-zinc-200 dark:border-zinc-800
                  bg-white dark:bg-zinc-900 p-4 cursor-pointer
                  hover:bg-zinc-50 dark:hover:bg-zinc-800/50
                  hover:border-zinc-300 dark:hover:border-zinc-700
                  transition-colors group"
    >
      <div className="flex items-end justify-between mb-3">
        <div>
          <div className="flex items-center gap-1">
            <span className="text-xs font-medium uppercase tracking-wider text-zinc-400 dark:text-zinc-500">
              Total Points
            </span>
            <ChevronRight className="w-3.5 h-3.5 text-zinc-400 dark:text-zinc-500 opacity-0 group-hover:opacity-100 transition-opacity" />
          </div>
          <div className="text-3xl font-bold tabular-nums text-zinc-900 dark:text-zinc-100 leading-none mt-0.5">
            {totalPoints}
          </div>
        </div>
        <div className="flex items-center gap-3 text-sm tabular-nums">
          <span className="text-emerald-600 dark:text-emerald-400 font-semibold">
            {record.wins}W
          </span>
          <span className="text-zinc-500 dark:text-zinc-400 font-medium">
            {record.draws}D
          </span>
          <span className="text-red-500 dark:text-red-400 font-semibold">
            {record.losses}L
          </span>
        </div>
      </div>

      {total > 0 && (
        <div className="flex h-2 rounded-full overflow-hidden gap-0.5">
          {record.wins > 0 && (
            <div
              className="bg-emerald-500 dark:bg-emerald-400 rounded-full"
              style={{ width: `${(record.wins / total) * 100}%` }}
            />
          )}
          {record.draws > 0 && (
            <div
              className="bg-zinc-300 dark:bg-zinc-600 rounded-full"
              style={{ width: `${(record.draws / total) * 100}%` }}
            />
          )}
          {record.losses > 0 && (
            <div
              className="bg-red-400 dark:bg-red-500 rounded-full"
              style={{ width: `${(record.losses / total) * 100}%` }}
            />
          )}
        </div>
      )}
    </div>
  )
}
